// API Configuration
export const API_BASE_URL = 'https://api.awm27.shop/api';

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'awm_auth_token',
  USER_DATA: 'awm_user_data',
  CART: 'awm_cart'
};

// App Configuration
export const APP_NAME = 'Amravati Wears Market';
export const APP_DESCRIPTION = 'Shop Your Favorite Local Clothes Online';

// Order Status
export const ORDER_STATUS = {
  PLACED: 'placed',
  CONFIRMED: 'confirmed',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled'
};

// Order Status Labels
export const ORDER_STATUS_LABELS = {
  placed: 'Order Placed',
  confirmed: 'Confirmed',
  shipped: 'Shipped',
  delivered: 'Delivered',
  cancelled: 'Cancelled'
};

// COD Fee Threshold
export const COD_FEE_THRESHOLD = 500;
export const COD_FEE_AMOUNT = 50;